import { useLocation } from 'react-router-dom';
import { Badge, Inline } from '@etg/wings';
import { useProperty, useSearch, useTranslation } from '@eti/providers';
import { TripCharacteristics, type BoundNew } from '@eti/schema-types';
import { routes } from '../../constants/routesAndApisConstants';
import { isTripWithDifferentOriginOrDestination } from '../../widgets/trip-details/utils/originDestinationUtil';
import { addLegendNumberToSegmentEvents } from '../../pages/traveler-details/utils/formatUtils';

export interface OnceWayTicketCombinationBadgeProps {
  tripCharacteristics: TripCharacteristics[];
  bounds: BoundNew[];
}

export default function OnceWayTicketCombinationBadge({
  tripCharacteristics,
  bounds,
}: OnceWayTicketCombinationBadgeProps) {
  const { t } = useTranslation();
  const { currentSearchData } = useSearch();
  const { p } = useProperty();

  const isDifferentAirportNotificationEnabled = p('Result.DifferentAirportNotification.Enabled');
  const boundsWithLegends: any = addLegendNumberToSegmentEvents(bounds as any);
  const location = useLocation();
  const isChangeTripPage = location.pathname.includes(routes.CHANGE_TRIP);

  const tripHasDifferentOriginOrDestination = isTripWithDifferentOriginOrDestination(
    currentSearchData?.routes ?? [],
    boundsWithLegends,
  );
  const shouldShowOneWayCombinationInfo = tripCharacteristics?.includes(
    TripCharacteristics.OneWayCombination,
  );

  const shouldShowDifferentAirportBadge =
    tripHasDifferentOriginOrDestination && isDifferentAirportNotificationEnabled;

  const getBadgesSRText = () => {
    const textsArray: string[] = [];

    if (!isChangeTripPage && shouldShowDifferentAirportBadge) {
      textsArray.push(t('Result.NearbyAirports.Badge.Text'));
    }

    if (shouldShowOneWayCombinationInfo) {
      textsArray.push(t('Air.TripInformation.OneWayCombination'));
    }
    return textsArray.join();
  };

  return (
    <>
      {shouldShowOneWayCombinationInfo && (
        <Inline aria-label={getBadgesSRText()}>
          <Badge aria-hidden data-testid="one-way-combination-badge" variant="information">
            {t('Air.TripInformation.OneWayCombination')}
          </Badge>
        </Inline>
      )}
    </>
  );
}
